import React from "react";
import styled, { css } from "styled-components";
import { EllipsisOutlined, DeleteOutlined, CopyOutlined, SettingOutlined, SettingFilled } from "@ant-design/icons";
import COLORS from "../../../constants/colors";

const hide = css`display: none;`;
const show = css`display: block;`;

const actionIconStyle = css`
  padding: 3px;
  font-size: 1rem;
  + .anticon {
    padding-top: 6px;
  }
`;

export const Container = styled.div`display: flex;`;

export const LearningUnitActionsContainer = styled.div`
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  min-height: 45px;
`;

export const ShowActionsIcon = styled(EllipsisOutlined).attrs({ className: "ShowActionsIcon" })`
  ${actionIconStyle}
  /* ${props => (props.show ? show : hide)}; */
`;

export const ActionIconsContainer = styled.div.attrs({ className: "ActionIconsContainer" })`
  display: flex;
  flex-direction: column;`;

export const RemoveFromPalette = styled(DeleteOutlined).attrs({ className: "RemoveFromPalette" })`${actionIconStyle}`;

export const CloneComponent = styled(CopyOutlined).attrs({ className: "CloneComponent" })`${actionIconStyle}`;

const SettingIcon = ({ iconTheme, ...props }) => 
  iconTheme === "filled" ? <SettingFilled {...props} /> : <SettingOutlined {...props} />;

export const Settings = styled(SettingIcon).attrs({ className: "Settings" })`${actionIconStyle}`;

// Container for child components
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 0.5px solid ${COLORS.LIGHTGRAY};
  border-radius: 4px;
  width: 100%;
  padding: 20px;
  background-color: ${COLORS.WHITE};
`;
